
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  TableContainer,
  Paper,
  Pagination,
  TablePagination,
  Toolbar,
  
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";




const SIDEBAR_WIDTH = 200; // Set to your sidebar's pixel width
const ROWS_PER_PAGE = 20;



export default function CategoryForm({ clientId, categoryType }) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editCategory, setEditCategory] = useState(null);
  const [formValues, setFormValues] = useState({ categoryname: "", description: "" });
  const [formOpen, setFormOpen] = useState(false);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);
const [rowsPerPage, setRowsPerPage] = useState(5); // default rows per page


  // Fetch categories and include default and client-specific on backend
  const fetchCategories = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/api/category", {
        params: { client_id: clientId, categorytype: categoryType },
      });
      setCategories(res.data);
      setError("");
    } catch {
      setError("Failed to load categories.");
    }
    setLoading(false);
  };


  useEffect(() => {
    if (clientId && categoryType) {
      fetchCategories();
    }
  }, [clientId, categoryType]);


  const openAddForm = () => {
    setEditCategory(null);
    setFormValues({ categoryname: "", description: "" });
    setFormOpen(true);
    setError("");
  };


  const openEditForm = (category) => {
    setEditCategory(category);
    setFormValues({
      categoryname: category.categoryname,
      description: category.description || "",
    });
    setFormOpen(true);
    setError("");
  };


  const closeForm = (_, reason) => {
    if (reason && reason === "backdropClick") return; // Prevent closing on outside click
    setFormOpen(false);
    setError("");
  };


  const handleFormChange = (e) => {
    setFormValues((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };


  const handleSubmit = async () => {
    if (!formValues.categoryname.trim()) {
      setError("Category name is required");
      return;
    }
    try {
      if (editCategory) {
        await axios.put(`/api/category/${editCategory.categoryid}`, formValues);
      } else {
        await axios.post("/api/category", { ...formValues, categorytype: categoryType, client_id: clientId });
      }
      closeForm();
      fetchCategories();
    } catch {
      setError("Error saving category. Possibly duplicate name.");
    }
  };


  const handleDelete = async (categoryid) => {
    if (!window.confirm("Are you sure you want to delete this category?")) return;
    try {
      await axios.delete(`/api/category/${categoryid}`);
      fetchCategories();
    } catch {
      alert("Failed to delete category");
    }
  };


  // Pagination calculations
  const pageCount = Math.ceil(categories.length / ROWS_PER_PAGE);
  const paginatedCategories = categories.slice(
    (page - 1) * ROWS_PER_PAGE,
    page * ROWS_PER_PAGE
  );


  const handlePageChange = (_, value) => {
    setPage(value);
  };


return (
  <Box
   sx={{
        width: "100%",
        minHeight: "100vh",
        p: { xs: 0, md: 0 },
        bgcolor: "#f8fafc",
      }}
    >
    {/* sx={{
      minHeight: "100vh",
      width: "100%",
      background: "#f8f9fb",
      marginLeft: `${SIDEBAR_WIDTH}px`,
      paddingTop: 0,
      paddingLeft: 0,
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
    }}
  > */}
   
  <Paper
  elevation={1}
  sx={{
    maxWidth: "1300px",
    margin: "0 auto",
    borderRadius: 3,
    boxShadow: "0 2px 10px 0 rgba(0,0,0,0.03)",
    mb: 2,
    mt: 0,
    overflow: "hidden",
  }}
>
  <Toolbar
    sx={{
      px: 1,
      py: 1,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      bgcolor: "#fff",
      borderBottom: "1px solid #f0f0f0",
    }}
    disableGutters
  >
    <Typography
      variant="h6"
      sx={{
        fontWeight: 600,
        fontSize: 20,
        letterSpacing: 0.5,
      }}
    >
      {categoryType} Categories
    </Typography>
    <Button
      onClick={openAddForm}
      variant="contained"
      sx={{ borderRadius: 2, textTransform: "none" }}
    >
      Add New
    </Button>
  </Toolbar>

  {loading ? (
    <Typography sx={{ px: 3, pt: 3 }}>Loading...</Typography>
  ) : categories.length === 0 ? (
    <Typography sx={{ px: 3, pt: 3 }}>No categories found.</Typography>
  ) : (
    <>
      <TableContainer sx={{ bgcolor: "#fff" }}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  fontWeight: 600,
                  bgcolor: "#f8fafb",
                  borderBottom: "2px solid #eee",
                  minWidth: 120,
                }}
                align="left"
              >
                Category Name
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 600,
                  bgcolor: "#f8fafb",
                  borderBottom: "2px solid #eee",
                  minWidth: 250,
                }}
                align="left"
              >
                Description
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  width: 120,
                  fontWeight: 600,
                  bgcolor: "#f8fafb",
                  borderBottom: "2px solid #eee",
                }}
              >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedCategories.map(({ categoryid, categoryname, description, client_id }) => {
              const isDefault = !client_id || client_id === 0;
              return (
                <TableRow key={categoryid} hover>
                  <TableCell align="left">{categoryname}</TableCell>
                  <TableCell align="left">{description}</TableCell>
                  <TableCell align="center">
                    <IconButton
                      onClick={() => openEditForm({ categoryid, categoryname, description })}
                      size="small"
                      color="info"
                      aria-label="edit"
                      disabled={isDefault}
                      title={isDefault ? "Cannot edit default category" : ""}
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton
                      onClick={() => handleDelete(categoryid)}
                      size="small"
                      color="error"
                      aria-label="delete"
                      disabled={isDefault}
                      title={isDefault ? "Cannot delete default category" : ""}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={categories.length}
        page={page - 1}
        onPageChange={(e, newPage) => setPage(newPage + 1)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(parseInt(e.target.value, 10));
          setPage(1);
        }}
        labelRowsPerPage="Rows per page"
        labelDisplayedRows={({ from, to, count }) =>
          `Showing ${from}-${to} of ${count}`
        }
        rowsPerPageOptions={[5, 10, 25]}
        sx={{
          ".MuiTablePagination-toolbar": { minHeight: 38, height: 38 },
          ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": {
            fontSize: 12,
          },
        }}
      />
    </>
  )}
</Paper>

    <Dialog
      open={formOpen}
      onClose={closeForm}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown={false}
    >
      <DialogTitle>
        {editCategory ? "Edit" : "Add"} {categoryType} Category
      </DialogTitle>
      <DialogContent>
        {error && (
          <Typography color="error" sx={{ mb: 1 }}>
            {error}
          </Typography>
        )}
        <TextField
          autoFocus
          margin="dense"
          label="Category Name"
          fullWidth
          name="categoryname"
          value={formValues.categoryname}
          onChange={handleFormChange}
        />
        <TextField
          margin="dense"
          label="Description"
          fullWidth
          multiline
          minRows={2}
          name="description"
          value={formValues.description}
          onChange={handleFormChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={closeForm}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          {editCategory ? "Update" : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  </Box>
);


}